import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import ComparisonsContainer from './comparisons/index';
import InstructionalAreasContainer from './instructional-areas/index';
import GrowthGoalsContainer from './growth-goals';
import GrowthOverTimeContainer from './growth-over-time/index';

export default CreateReactClass({
    displayName: 'modules',

    propTypes: {
        courseName: PropTypes.string,
        selectedTermHasCourseSpecificTestEvent: PropTypes.bool.isRequired,
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        selectedTermNumber: PropTypes.number.isRequired,
        isMostRecentTerm: PropTypes.bool,
        studentBid: PropTypes.string.isRequired,
        studentInfo: PropTypes.instanceOf(Immutable.Map),
        testEvents: PropTypes.instanceOf(Immutable.List).isRequired, // NOTE: Might be empty
        batchInfo: PropTypes.object /* Only exists when in Batch Print mode */,
        isSingleStudentMode: PropTypes.bool.isRequired,
        terms: PropTypes.instanceOf(Immutable.List),
        studentTermData: PropTypes.instanceOf(Immutable.List),
        expandedModule: PropTypes.string,
        currentTerm: PropTypes.instanceOf(Immutable.Map),
        modalReferences: PropTypes.object,
        futureTermsSetup: PropTypes.bool,
        selectedGoals: PropTypes.instanceOf(Immutable.List),
        growthGoals: PropTypes.instanceOf(Immutable.List),
        linkingStudiesData: PropTypes.object,
        linkingStudiesLoaded: PropTypes.bool.isRequired,
        ritQuintiles: PropTypes.instanceOf(Immutable.Map).isRequired,
        ritQuintilesLoaded: PropTypes.bool.isRequired,

        growthGoalNormsForStudent: PropTypes.instanceOf(Immutable.Map).isRequired,
        growthGoalNormsForStudentLoaded: PropTypes.bool.isRequired,
        growthProjections: PropTypes.instanceOf(Immutable.List),
        growthProjectionsLoaded: PropTypes.bool.isRequired,
        districtAveragesLoaded: PropTypes.bool.isRequired,
        districtAverages: PropTypes.instanceOf(Immutable.Map).isRequired,
        keystoneTestEvent: PropTypes.object,
    },

    render() {
        return (
            <React.Fragment>
                <div className="module-formatter">
                    <ComparisonsContainer
                        key="comparisons-container"
                        studentBid={this.props.studentBid}
                        studentTermData={this.props.studentTermData}
                        subject={this.props.subject}
                        selectedTermNumber={this.props.selectedTermNumber}
                        testEvents={this.props.testEvents}
                        mode={'normal'}
                        batchInfo={this.props.batchInfo}
                        keystoneTestEvent={this.props.keystoneTestEvent}
                    />

                    <InstructionalAreasContainer
                        studentBid={this.props.studentBid}
                        studentInfo={this.props.studentInfo}
                        subject={this.props.subject}
                        selectedTermNumber={this.props.selectedTermNumber}
                        testEvents={this.props.testEvents}
                        batchInfo={this.props.batchInfo}
                        mode={'normal'}
                        selectedGoals={this.props.selectedGoals}
                        isSingleStudentMode={this.props.isSingleStudentMode}
                        expandedModule={this.props.expandedModule}
                    />

                    <GrowthGoalsContainer
                        key="growth-goals-container"
                        subject={this.props.subject}
                        selectedTermNumber={this.props.selectedTermNumber}
                        studentBid={this.props.studentBid}
                        testEvents={this.props.testEvents}
                        growthGoals={this.props.growthGoals}
                        terms={this.props.terms}
                        studentTermData={this.props.studentTermData}
                        currentTerm={this.props.currentTerm}
                        linkingStudiesData={this.props.linkingStudiesData}
                        linkingStudiesLoaded={this.props.linkingStudiesLoaded}
                        ritQuintiles={this.props.ritQuintiles}
                        ritQuintilesLoaded={this.props.ritQuintilesLoaded}
                        modalReferences={this.props.modalReferences}
                        growthGoalNormsForStudent={this.props.growthGoalNormsForStudent}
                        growthGoalNormsForStudentLoaded={this.props.growthGoalNormsForStudentLoaded}
                        growthProjections={this.props.growthProjections}
                        growthProjectionsLoaded={this.props.growthProjectionsLoaded}
                        expandedModule={this.props.expandedModule}
                        mode={'normal'}
                        keystoneTestEvent={this.props.keystoneTestEvent}
                    />
                </div>

                <GrowthOverTimeContainer
                    key="got-container"
                    courseName={this.props.courseName}
                    selectedTermHasCourseSpecificTestEvent={this.props.selectedTermHasCourseSpecificTestEvent}
                    selectedTermNumber={this.props.selectedTermNumber}
                    studentBid={this.props.studentBid}
                    isMostRecentTerm={this.props.isMostRecentTerm}
                    testEvents={this.props.testEvents}
                    subject={this.props.subject}
                    selectedSubject={this.props.subject}
                    mode={'normal'}
                    studentTermData={this.props.studentTermData}
                    linkingStudiesData={this.props.linkingStudiesData}
                    linkingStudiesLoaded={this.props.linkingStudiesLoaded}
                    terms={this.props.terms}
                    currentTerm={this.props.currentTerm}
                    futureTermsSetup={this.props.futureTermsSetup}
                    ritQuintiles={this.props.ritQuintiles}
                    ritQuintilesLoaded={this.props.ritQuintilesLoaded}
                    districtAveragesLoaded={this.props.districtAveragesLoaded}
                    districtAverages={this.props.districtAverages}
                    growthProjectionsLoaded={this.props.growthProjectionsLoaded}
                    modalReferences={this.props.modalReferences}
                    growthGoals={this.props.growthGoals}
                />
            </React.Fragment>
        );
    },
});
